<script setup lang="ts">
  import {
    Dialog,
    DialogScrollContent,
    DialogTrigger
  } from '@gat-ship/vue-components/dialog'
</script>
<template>
  <Dialog>
    <DialogTrigger v-if="$slots.trigger" as-child>
      <slot name="trigger" />
    </DialogTrigger>
    <DialogScrollContent>
      <slot />
    </DialogScrollContent>
  </Dialog>
</template>
